import React, { useRef } from "react";
import DropdownPopup, { DropdownPopupRef } from "ui-components/dropdown-popup/dropdownPopup";
import Button, { ButtonSizes, ButtonThemes } from "ui-components/button/button";
import "./schedulerActionsMenu.scss";

export interface SchedulerActionsMenuProps {
  onEditScheduleDetails: () => void;
  onCreateNewSchedule: () => void;
  onCreateLane: () => void;
  onManageSchedules: () => void;
}

const SchedulerActionsMenu: React.FC<SchedulerActionsMenuProps> = ({
  onEditScheduleDetails,
  onCreateNewSchedule,
  onCreateLane,
  onManageSchedules,
}) => {
  const popupRef = useRef<DropdownPopupRef>(null);

  const handleItemClick = (action: () => void) => {
    action();
    popupRef.current?.close();
  };

  return (
    <DropdownPopup
      ref={popupRef}
      uncontrolled
      triggerElement={
        <span className="scheduler-actions-menu__trigger">
          <Button theme={ButtonThemes.grayInverted} size={ButtonSizes.auto}>...</Button>
        </span>
      }
      className="scheduler-actions-menu"
      position="bottom right"
      contentStyle={{
        padding: 0,
        border: "none",
        boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
        borderRadius: 4,
        zIndex: 22,
      }}
      overlayStyle={{
        zIndex: 21,
        backgroundColor: "transparent",
      }}
    >
      <div className="scheduler-actions-menu__content">
        <button
          type="button"
          className="scheduler-actions-menu__item"
          onClick={() => handleItemClick(onEditScheduleDetails)}
        >
          Edit Schedule Details
        </button>
        <button
          type="button"
          className="scheduler-actions-menu__item"
          onClick={() => handleItemClick(onCreateNewSchedule)}
        >
          Create New Schedule
        </button>
        <button
          type="button"
          className="scheduler-actions-menu__item"
          onClick={() => handleItemClick(onCreateLane)}
        >
          Create Lane
        </button>
        <hr className="scheduler-actions-menu__divider" />
        <button
          type="button"
          className="scheduler-actions-menu__item"
          onClick={() => handleItemClick(onManageSchedules)}
        >
          Manage Schedules
        </button>
      </div>
    </DropdownPopup>
  );
};

export default SchedulerActionsMenu;
